import React, { PureComponent, PropTypes } from 'react';
import SaveCancelModal from '../modals/SaveCancelModal';
import { FILTER_DATA_SHAPE, CourtSelect } from '../../GameDay/components/forms/AdminGamesFilter';

export class EditAllForm extends PureComponent {
  static propTypes = {
    filterData: FILTER_DATA_SHAPE.isRequired,
    editAll: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  render() {
    const { editAll, onChange, filterData } = this.props;

    const { court } = editAll;

    return (
      <div>
        <div>
          <label>Change Court</label>
          <CourtSelect
            valueToString={({ name, venue }) => `${name} - ${venue.name}`}
            options={filterData.courts} value={court} onChange={court => onChange({ ...editAll, court })}/>
        </div>
      </div>
    );
  }
}

export default class EditAllGamesModal extends PureComponent {
  static propTypes = {
    filterData: FILTER_DATA_SHAPE.isRequired,
    editAll: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    editAll: null
  };

  render() {
    const { editAll, onSave, filterData, onChange, ...rest } = this.props;

    const canSave = _.keys(editAll).length > 0;

    return (
      <SaveCancelModal title="Edit All Games" onSave={onSave} canSave={canSave} {...rest}>
        {editAll && <EditAllForm filterData={filterData} onChange={onChange} editAll={editAll}/>}
      </SaveCancelModal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/modals/EditAllGamesModal.jsx